var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full pt-32 flex iems-center justify-center"},[_c('loader-balls')],1)}
var staticRenderFns = []

export { render, staticRenderFns }